// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_widget_widget_component_ts":"c09f617a591b3774","src_app_modules_main_main_module_ts":"02c58a18ae2e5228","src_app_modules_main-home-value_main-home-value_module_ts":"369099f66a4b1139","src_app_modules_stepper_stepper_module_ts":"cb3186e58d7c8859"}[chunkId] + ".js";
};